import { useLocalization } from 'src/utils/useLocalization';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import './styles.scss';

export interface IChild {
    name: string;
    path?: string;
    icon?: string;
    handler?: Function;
}

interface IArgs {
    submenus?: Array<IChild>;
    open: boolean;
    handlerChange?: Function;
    handlerItemChange?: Function;
    showSelected?: boolean;
    showSelectedIcon?: boolean;
    defaultSelected?: string;
    children?: any;
    right?: string;
    refEle?: any;
    isDealership?: boolean;
    shouldUseModal?: boolean;
    showSearch?: boolean;
}

const Dropdown = ({
    submenus,
    open,
    refEle,
    handlerChange,
    handlerItemChange,
    defaultSelected,
    showSelectedIcon,
    children,
    right,
    isDealership = false,
    showSearch = false,
}: IArgs) => {
    const { t } = useTranslation();
    const { labelText } = useLocalization();
    const [selected, setSelected] = useState<string>(defaultSelected || '');
    const [searchTerm, setSearchTerm] = useState<string>('');

    const onMouseEnter = () => {
        // eslint-disable-next-line no-magic-numbers
        if (window.innerWidth > 960 && handlerChange) {
            handlerChange(true);
        }
    };

    useEffect(() => {
        const handler = (event: any) => {
            if (
                open &&
                refEle &&
                refEle.current &&
                !refEle.current.contains(event.target)
            ) {
                if (handlerChange) handlerChange(false);
            }
        };

        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [open, refEle]);
    useEffect(() => {
        setSelected(defaultSelected as string);
    }, [defaultSelected]);

    useEffect(() => {
        if (!open) {
            setSearchTerm('');
        }
    }, [open]);

    const filteredSubmenus = submenus?.filter((submenu) =>
        t(submenu.name).toLowerCase().includes(searchTerm.toLowerCase()),
    );

    if (children) {
        return (
            <ul
                className={`dropdown-search ${open ? 'show' : ''}`}
                onMouseEnter={onMouseEnter}
            >
                {children}
            </ul>
        );
    }

    return (
        <ul
            className={`dropdown-search ${open ? 'show' : ''} ${
                isDealership ? 'dealership_large' : ''
            }`}
            style={{ right: `${right ? right : '0'}px` }}
            onMouseEnter={onMouseEnter}
        >
            {
                // eslint-disable-next-line no-magic-numbers
                showSearch && submenus && submenus.length > 0 && (
                    <li
                        className='dropdown-search-input-option'
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            type='text'
                            placeholder={t('Search list ...')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className='dropdown-search-input'
                        />
                    </li>
                )
            }

            {/* Menu Items */}
            {filteredSubmenus && filteredSubmenus.length ? (
                filteredSubmenus.map((submenu, index) => (
                    <li key={index} className='menu-items'>
                        {submenu.name ? (
                            handlerChange ? (
                                <a
                                    href={submenu?.path || '#'}
                                    onClick={() => {
                                        if (handlerItemChange) {
                                            handlerItemChange(submenu);
                                            setSelected(submenu.name);
                                        }
                                    }}
                                    className={`${
                                        submenu.name === selected
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    {t(submenu.name)}
                                    {showSelectedIcon &&
                                        submenu.name === selected && (
                                            <i
                                                className='c-icon c-icon--[semantic-checkmark] u-ml-small'
                                                aria-hidden='true'
                                                role='img'
                                            />
                                        )}
                                </a>
                            ) : (
                                <a href={submenu.path}>{t(submenu.name)}</a>
                            )
                        ) : (
                            <span>{t(submenu.name)}</span>
                        )}
                    </li>
                ))
            ) : (
                <li>
                    <span>
                        {searchTerm
                            ? t('No matching results')
                            : labelText.LABEL_TEXT_DASH_NORESULTS}
                    </span>
                </li>
            )}
        </ul>
    );
};

export default Dropdown;
